import React from 'react';
import PropTypes from 'prop-types';
import AccountsRow from './AccountsRow';
import AccountsHeader from './AccountsHeader';
import TableFooter from '../helpers/TableFooter';
import { isEmpty } from 'lodash';
import { tableNoResultsDefault, tableSpinnerDefault } from '../helpers/TableHelpers';
import { isAdminDashboard } from 'utils/authScopes';

const ACCOUNTS_COLUMN_NUMBER = 11;

const AccountsTable = ({ auth, isLoading, accounts, meta, onAccount, onPageChange, onSortChange }) => {
  const rows = accounts.map(row => (
    <AccountsRow key={`${row.id}`} data={row} onAccount={onAccount} auth={auth}/>
  ));
  const columnsCount = isAdminDashboard(auth) ? ACCOUNTS_COLUMN_NUMBER + 1 : ACCOUNTS_COLUMN_NUMBER;

  if (isLoading) {
    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='table-scroll'>
          <table className='o-table o-table--bordered'>
            <AccountsHeader meta={meta} onSortChange={onSortChange} auth={auth}/>
            <tbody>
              { tableSpinnerDefault(columnsCount) }
            </tbody>
          </table>
        </div>
        { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
      </div>
    )
  }

  if (!isLoading && isEmpty(accounts)) {
    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='table-scroll'>
          <table className='o-table o-table--bordered'>
            <AccountsHeader meta={meta} onSortChange={onSortChange} auth={auth}/>
            <tbody>
              { tableNoResultsDefault(columnsCount) }
            </tbody>
          </table>
        </div>
        { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
      </div>
    )
  }

  return (
    <div className='u-margin-bottom--gutter2x'>
      <div className='table-scroll'>
        <table className='o-table o-table--bordered'>
          <AccountsHeader meta={meta} onSortChange={onSortChange} auth={auth}/>
          <tbody>
            { rows }
          </tbody>
        </table>
      </div>
      { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
    </div>
  );
}

AccountsTable.propTypes = {
  auth: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onAccount: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onBlock: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired,
  accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default AccountsTable;
